import type { CatalogProduct } from "@/lib/comparison-catalog";

/** Providers with a themed brand chip (--cf-ui-provider-*); everyone else gets a quiet tile tinted
 * with the product's own catalog colour. */
const branded: Record<string, string> = { openai: "openai", anthropic: "anthropic", google: "google", mistral: "mistral", "mistral ai": "mistral", deepseek: "deepseek" };

export function ProductMark({ product, size = "md" }: { product: CatalogProduct; size?: "sm" | "md" | "lg" }) {
  const brand = branded[product.provider.toLowerCase()];
  return <span className={`vc-mark vc-mark-${size}`} data-provider={brand} aria-hidden="true"
    style={brand ? undefined : { background: `color-mix(in srgb, ${product.color} 16%, var(--cf-ui-surface))`, borderColor: `color-mix(in srgb, ${product.color} 34%, var(--cf-ui-border))` }}>
    {product.provider.replace(/[^\p{L}\p{N}]/gu, "").slice(0, 2)}
  </span>;
}
